import React, { useState, useEffect } from "react";
import CommentCard from "./CommentCard";
import CommentInputField from "./CommentInputField";
import { makeStyles, Typography, Container } from "@material-ui/core";

const useStyles = makeStyles({
  commentTitle: {
    margin: "5.75rem 0 2.312rem 0",
  },
  hideComments: {
    display: "none",
  },
});

const CommentSection = ({ blogId }) => {
  const classes = useStyles();
  const [comments, setComments] = useState({ commentsList: [], isLoad: false });
  const changeDate = (date) => {
    const change = new Date(date);
    return change.toDateString();
  };
  useEffect(() => {
    const fetchCommentsUrl = `https://natakallam.com/wp-json/wp/v2/comments?post=${blogId}`;

    fetch(fetchCommentsUrl)
      .then((resp) => resp.json())
      .then((data) => {
        setComments({ commentsList: data, isLoad: true });
      });
  }, [blogId]);

  return (
    <Container
      className={!comments.isLoad ? classes.hideComments : ""}
      maxWidth="md"
    >
      <Typography className={classes.commentTitle} variant="h2" color="primary">
        Comments
      </Typography>
      {comments.commentsList.map((comment) => (
        <CommentCard
          key={comment.id}
          comment={comment.content.rendered}
          avatar={comment.author_name.charAt(0)}
          person={comment.author_name}
          job={changeDate(comment.data)}
        />
      ))}
      <CommentInputField blogId={blogId} />
    </Container>
  );
};

export default CommentSection;
